<div class="page-wrapper">
    <div class="page-content">
        <div class="app-brand">{{ strings.appLongName }}</div>
        <mat-card appearance="outlined">
            <mat-card-content class="flex flex-col items-center place-content-center">
                <h1 class="font-normal">Logging in to {{ connectionInfo.name }}</h1>
            </mat-card-content>
        </mat-card>
    </div>
</div>
